import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';
import { ServerInfo } from './ServerInfo';

const appInsights = new ApplicationInsights({ config: {} });
const reactPlugin = new ReactPlugin();

(async function () {
  const browserHistory = createBrowserHistory({ basename: '' });

  const settings = await ServerInfo.get();

  const appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: settings.appInsightsKey,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history: browserHistory }
      }
    }
  
  });

  appInsights.loadAppInsights();

  appInsights.addTelemetryInitializer((telemetryItem: any) => {
    telemetryItem.tags['ai.cloud.role'] = "AVIRPFG_WEB_" + settings.env.toUpperCase();
  });
}())

export { reactPlugin, appInsights };